// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#A0522D', // Sienna brown (adjust as needed)
    },
    secondary: {
      main: '#F5F5DC', // Beige (adjust as needed)
    },
    background: { // Customize background colors
      default: '#FFF8DC', // Cornsilk, or another soft beige/off-white
      paper: '#FAEBD7', // AntiqueWhite for slightly different paper background
    },
    text: { // Customize text colors for better contrast
      primary: '#8B4513', // Darker brown for main text
      secondary: '#A67B5B', // Slightly lighter brown for secondary text
    },

    // Add more color customizations as needed (error, warning, info, etc.)
  },
  typography: {
    fontFamily: 'Arial, sans-serif', // Set your desired font
  },


});

export default theme;
